import { jsx } from "react/jsx-runtime";
import { c as classNames } from "../../../../index-e71f83b5.js";
import React__default, { useState } from "react";
import { T as TooltipPopoverWrapper, p as propTypes } from "../../../../TooltipPopoverWrapper-c4dc3a40.js";
import { COMMON_CLASSNAME } from "../../../constants.js";
import "../../../../_commonjsHelpers-0c53d963.js";
import "../../../../utils-f8d1c624.js";
import "react-dom";
import "../../../../Popper-b45e70f5.js";
import "../../../../Manager-52cb3832.js";
import "../../../../Fade-1a465599.js";
import "../../../../Transition-c07376a3.js";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends.apply(this, arguments);
}
var defaultProps = {
  placement: "top",
  autohide: !0,
  placementPrefix: "bs-tooltip",
  trigger: "hover focus"
};
function Tooltip(props) {
  var arrowClasses = classNames("tooltip-arrow", props.arrowClassName), popperClasses = classNames("tooltip", "show", props.popperClassName), classes = classNames("tooltip-inner", props.innerClassName);
  return /* @__PURE__ */ React__default.createElement(TooltipPopoverWrapper, _extends({}, props, {
    arrowClassName: arrowClasses,
    popperClassName: popperClasses,
    innerClassName: classes
  }));
}
Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
function FlashTooltip(props) {
  var _a;
  const { targetId, placement = "top", children, className, ...rest } = props, [tooltipOpen, setTooltipOpen] = useState(!1), toggle = () => setTooltipOpen(!tooltipOpen), targetIdString = typeof targetId == "string" ? targetId : targetId.id ? targetId.id : (_a = targetId.current) == null ? void 0 : _a.id;
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      target: targetId,
      "data-testid": `${targetIdString}-tooltip`,
      placement,
      isOpen: tooltipOpen,
      toggle,
      className: `${COMMON_CLASSNAME} flash-tooltip`,
      innerClassName: className,
      popperClassName: classNames("rounded shadow-flash-300", {
        "mb-flash-050": placement.includes("top"),
        "ms-flash-050": placement.includes("right"),
        "mt-flash-050": placement.includes("bottom"),
        "me-flash-050": placement.includes("left")
      }),
      ...rest,
      children
    }
  );
}
export {
  FlashTooltip as default
};
//# sourceMappingURL=FlashTooltip.js.map
